/**
 * 给传入组件添加操作区（新增、选中、删除）
 *
 * created by liyaoh 2021-06-16
 */
import React from "react";
import classNames from "classnames";
import WidgetJSLoader from "../../../pages/NewHome/CreaterForWidget/WidgetJSLoader";
import QuickLaunchSide from "Widgets/QuickLaunch/side";
import AppGroupSide from "Pages/NewHome/AppGroup/AppGroupSide";
import { checkApp } from "../../../pages/NewHome/utilService";
import platform from "Pub/js/platform";
const { NCCheckbox } = platform.base;

export default function useOprArea(params, ContentComponent) {
    return class OprArea extends React.Component {
        state = {
            customArea: null,
            sideCom: null, // 侧拉编辑面板
        };

        componentDidMount() {
            const newParams = params(this.props);
            const { needEdit, item, isShow } = newParams;
            const checkItem = checkApp(item);
            if (needEdit && checkItem.isWidget && isShow) {
                if (checkItem.isPublished && !(checkItem.isIndicatorCard || checkItem.isBillStatistics)) {
                    // 发布出的小部件仅有公共配置能力（指标卡和单据统计除外，使用自定义的）
                } else if (checkItem.isQuickLaunch) { // 快速发起
                    this.setState({ sideCom: QuickLaunchSide });
                } else if (checkItem.isCommonUsedApp) { // 常用应用
                    this.setState({ sideCom: AppGroupSide });
                } else {
                    if (item.target_path) {
                        WidgetJSLoader(item.target_path, key => {
                            const sideCom = window[key].default.SidePanel;
                            if (sideCom) {
                                this.setState({ sideCom });
                            }
                        });
                    }
                }
            }
        }

        //渲染右上角操作区
        renderOperateArea = newParams => {
            const { isChecked, onCheck, onDelete, isScale, needCheckbox = true, onEdit, item, needEdit } = newParams;
            const { sideCom } = this.state;
            const checkItem = checkApp(item);
            return (
                <div className={classNames("opr-area nodrag", { scale: isScale })}>
                    {this.state.customArea}
                    {/* 有自定义侧拉或者公共配置能力的 */}
                    {needEdit && (sideCom || item.iscommon_configuration || checkItem.isApp) && <i
                        fieldid={`widget_edit_${item.appcode}`}
                        className="iconfont icon-bianji"
                        onClick={() => { onEdit && onEdit(sideCom); }}
                        // style={{ fontSize: '12px' }}
                    />}
                    {needCheckbox && <NCCheckbox checked={isChecked} onChange={onCheck} />}
                    {newParams.renderDeleteBtn || (
                        <i
                            fieldid={`widget_delete_${item.appcode}`}
                            className="iconfont icon-guanbi2"
                            onClick={onDelete}
                            style={{ marginRight: 0 }}
                        />
                    )}
                </div>
            );
        };

        //渲染自定义区域
        renderCustomArea = area => {
            this.setState({ customArea: area });
        };
        render() {
            const newParams = params(this.props);
            if (!newParams.isShow) {return <ContentComponent {...this.props} />;}
            return (
                <React.Fragment>
                    <ContentComponent
                        renderEditCustomArea={this.renderCustomArea}
                        {...this.props}
                    />
                    {this.renderOperateArea(newParams)}
                </React.Fragment>
            );
        }
    };
}
